export type WorkspaceDropdownProject = {
  id: string;
  name: string;
  archived: boolean;
  trialExpiryDate?: string | null;
};

export const WORKSPACE_RECENT_PROJECTS_LIMIT = 3;

export const formatWorkspaceRole = (role: string): string =>
  role ? role.charAt(0).toUpperCase() + role.slice(1) : "";

export const sortProjectsForRecentMenu = (
  projects: WorkspaceDropdownProject[],
  currentProjectId?: string | null,
  limit = WORKSPACE_RECENT_PROJECTS_LIMIT
): { recentProjects: WorkspaceDropdownProject[]; totalCount: number; hasMore: boolean } => {
  const totalCount = projects.length;

  if (totalCount === 0) {
    return { recentProjects: [], totalCount: 0, hasMore: false };
  }

  const currentProject =
    currentProjectId != null
      ? projects.find((project) => project.id === currentProjectId)
      : undefined;

  const otherProjects = projects.filter((project) => project.id !== currentProjectId);
  const sortedOthers = [...otherProjects].sort((left, right) =>
    left.name.localeCompare(right.name, undefined, { sensitivity: "base" })
  );

  const ordered = currentProject ? [currentProject, ...sortedOthers] : sortedOthers;
  const recentProjects = ordered.slice(0, limit);
  const hasMore = totalCount > recentProjects.length;

  return { recentProjects, totalCount, hasMore };
};

export const getWorkspaceTriggerSubtitle = ({
  isSettingsShell,
  currentProjectName,
  projectCount,
}: {
  isSettingsShell: boolean;
  currentProjectName?: string | null;
  projectCount: number;
}): string => {
  if (isSettingsShell) {
    return "Workspace settings";
  }

  const trimmedProjectName = currentProjectName?.trim();
  if (trimmedProjectName) {
    return trimmedProjectName;
  }

  if (projectCount > 0) {
    return formatProjectCount(projectCount);
  }

  return "Workspace";
};

export const formatProjectCount = (projectCount: number): string =>
  `${projectCount} ${projectCount === 1 ? "project" : "projects"}`;

export const getWorkspaceSwitcherSubtitle = (role: string, projectCount: number): string => {
  const formattedRole = formatWorkspaceRole(role);
  const projectPart = formatProjectCount(projectCount);
  return formattedRole ? `${formattedRole} · ${projectPart}` : projectPart;
};
